import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Tooltip } from '../../model/content/contentTooltip.model';
import { CommonService } from '../../services/common.service';
import { HelpModalDirective } from '../help-modal.directive';

declare let delta: any;

@Component({
  selector: 'ngc-cabin-experiences',
  templateUrl: 'cabin-experiences.component.html'
})
export class CabinExperiencesComponent implements AfterViewInit {
  @ViewChild('helpDialog') helpDialog: any;
  isModalShown = false;
  helpModalDir: HelpModalDirective;
  tooltipContent: Tooltip;

  modalConfig = {
    animated: false,
    show: true
  };

  constructor(
    public bsModalRef: BsModalRef,
    private elementRef: ElementRef,
    private srv: CommonService
  ) {}

  close() {
    this.bsModalRef.hide();
    document.getElementsByTagName('html')[0].classList.remove('no-scroll');
  }

  ngAfterViewInit() {
    this.srv.trapFocusInsideModal(this.elementRef);
  }
}
